import { classes, selectors } from './lib';

const body = document.querySelector<HTMLElement>('body');

export const showPopup = async (ref: string) => {
	// Show the popup with the given ID
	const popup = document.querySelector<HTMLElement>(`${selectors.popupContainer}[data-popup-ref="${ref}"]`);
	if (!popup) {
		console.error(`Error showing popup "${ref}": Popup with that reference not found.`);
		return;
	}

	popup.hidden = false;

	const popupContainer = document.querySelector<HTMLElement>(`${selectors.popupContainer}[data-popup-ref="${ref}"]`);
	// Show the popup container and add the visible class
	popupContainer?.classList.toggle(classes.visibleClass, true);
	body?.classList.add(classes.popupOpen);
};

export const hidePopup = () => {
	body?.classList.remove(classes.popupOpen);

	document.querySelectorAll<HTMLElement>(selectors.popupContainer).forEach((popup) => {
		popup.classList.remove(classes.visibleClass);
		popup.hidden = true;
	});

	// Stop YouTube videos
	document.querySelectorAll<HTMLElement>(`${selectors.popupVideos}, ${selectors.selfHostedVideo}`).forEach((video) => {
		// check if video is playing
		let src = video.getAttribute('src');
		if (!src) {
			return;
		}

		src = src.replace('autoplay=1', 'autoplay=0');
		src = src.replace('mute=1', 'mute=0');
		video.setAttribute('src', src);
	});
};
